import React from 'react'
import { Button, ButtonProps } from 'src/antd'
import styled from 'styled-components'

import { CaretDownFilled } from 'src/icons/antd-compat'
import { bgHover, gray600 } from 'src/styles/color-theme'

const StyledButton = styled(Button)`
  padding: 0 12px;
  height: 40px;
  border: none;
  box-shadow: none;
  width: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background-color: ${bgHover};
  }

  svg {
    font-size: 16px;
  }
`

const StyledCaretDownFilled = styled(CaretDownFilled)`
  svg {
    font-size: 12px;
    color: ${gray600};
  }
`

export type TFilterMenuButtonProps = ButtonProps & {
  withCaretIcon?: boolean
}

/**
 * `forwardRef` is load-bearing, not tidiness. This button is the trigger for
 * several `src/antd/Dropdown` popups (the toolbar's Action and Export menus,
 * the upload menus, the filter date picker), and the shadcn Dropdown binds its
 * trigger with Radix `asChild` — which hands the child a ref and ANCHORS the
 * popup to it. A plain function component drops that ref silently, and the
 * menu then opens correctly but positioned from a 0x0 reference at the origin,
 * i.e. off-screen. `src/antd/overlay/refCapableTrigger` is the seam-side guard
 * for children that cannot take one; this is why this one does not need it.
 */
export const FilterMenuButton = React.forwardRef<
  HTMLElement,
  TFilterMenuButtonProps
>(({ children, withCaretIcon, ...props }, ref) => {
  return (
    <StyledButton type="text" {...props} ref={ref}>
      {children}
      {withCaretIcon && (
        <div style={{ fontSize: 0 }}>
          <StyledCaretDownFilled />
        </div>
      )}
    </StyledButton>
  )
})

FilterMenuButton.displayName = 'FilterMenuButton'
